import { Grid, Skeleton } from "@mui/material"

const ToolbarSkeleton = () => {
	return (
		<Grid mb={2}>
			<Skeleton variant="rounded" width={'100%'} height={88} />
		</Grid>
	)
}

export default ToolbarSkeleton;